import React from 'react';

import InvalidImg from '@/assets/img_shixiao.png';
import styles from './index.module.less';
import { DEVIS_ID_KEY } from '@/services/const';

const InvalidPage: React.FC = () => {
  return (
    <div className={styles['invalid']}>
      <img className={styles['invalid-img']} src={InvalidImg} alt="" />
      <div className={styles['invalid-text']}>
        链接已失效, DEVIS_ID：{localStorage.getItem(DEVIS_ID_KEY)}
      </div>
    </div>
  );
};

export default React.memo(InvalidPage);
